import { FormArray } from '@angular/forms';
import { addError, removeError } from '@core/utils/error-functions';


function contactItemValueDuplicated(contactItemsArray: FormArray, itemName: string, nameField: string): any {
  contactItemsArray.controls.forEach((contactItemForm) => {
    const itemsWithSameNumber = contactItemsArray.controls.filter((anotherItemForm) => {
      return anotherItemForm.value[nameField] === contactItemForm.value[nameField];
    });

    itemsWithSameNumber.forEach((control) => {
      const isDuplicated = itemsWithSameNumber.length > 1;
      const nameControl = control.get(nameField);
      const nameControlCamelCase = nameField[0].toUpperCase() + nameField.slice(1);

      if (isDuplicated) {
        addError(nameControl, `${itemName}${nameControlCamelCase}Duplicated`);
      } else {
        removeError(nameControl, `${itemName}${nameControlCamelCase}Duplicated`);
      }
    });
  });

  return null;
}

export class ContactItemValidator {
  static phoneNumberDuplicated(contactPhonesArray: FormArray): any {
    return contactItemValueDuplicated(contactPhonesArray, 'phone', 'number');
  }

  static emailAddressDuplicated(contactEmailsArray: FormArray): any {
    return contactItemValueDuplicated(contactEmailsArray, 'email', 'emailAddress');
  }
}
